export enum Pages {
  initialPage = 1,
  shopList = 2,
  confirmationPage = 3
}
